import { INFINITY_TIME } from 'components/Chat/constants/messages';

export const canSendMessage = (
  nextMessageTime: number,
  syncTime: () => number,
) =>
  Math.max(0, nextMessageTime - syncTime()) === 0 &&
  nextMessageTime !== INFINITY_TIME;
